import { Stack } from "@mui/material";
import { Task } from "src/api/types";
import Order from "src/components/Order";
import OrderProvider from "src/context/OrderProvider/OrderProvider";
import TaskWrapper from "src/wrappers/TaskWrapper";

interface Props {
  task: Task;
  onSuccess: () => Promise<void>;
}

const AddTrackingTask = ({ onSuccess, task }: Props) => {
  return (
    <OrderProvider orderId={task.resource_id}>
      <Stack gap={2}>
        <TaskWrapper task={task}>
          <Order onSuccess={onSuccess} />
        </TaskWrapper>
      </Stack>
    </OrderProvider>
  );
};

export default AddTrackingTask;
